import { render } from "./Scalepriceeditor.vue?vue&type=template&id=71967172&scoped=true"
import script from "./Scalepriceeditor.vue?vue&type=script&lang=js"
export * from "./Scalepriceeditor.vue?vue&type=script&lang=js"

import "./Scalepriceeditor.vue?vue&type=style&index=0&id=71967172&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71967172"]])

export default __exports__